import Alpine from 'alpinejs'

Alpine.data('scrollStage', () => ({

    items: [],
    visibleItemIndex: 0,
    fireNextItemVisibleEvent: true,
    
    init() {
        this.$el.querySelectorAll('[data-item]').forEach((item, i) => {
            this.items.push({
                node: item,
                name: item.getAttribute('data-item'),
                index: i,
            })
        })
        
        // detect current visible item when scrolling
        
        this.$el.addEventListener('scroll', () => this.determineVisibleItem(), { passive: true })
        
        // emit event when different item becomes visible
        
        this.$watch('visibleItemIndex', (index, indexOld) => {
            if(index !== indexOld) {
                const item = this.items[index]
                this.$dispatch('scroll-stage-item-visible', { name: item.name })
            }
        })
        
        this.determineVisibleItem()
    },
    
    scrollToItem(itemName) {
        const item = this.items.find(item => item.name === itemName)
        if(!item || item.index === this.visibleItemIndex) {
            return
        }
        this.$el.style.scrollBehavior = 'unset';
        const slideRect = item.node.getBoundingClientRect()
        const sliderRect = this.$el.getBoundingClientRect()
        const scrollX = slideRect.x - sliderRect.x
        this.$el.scrollLeft += scrollX
        this.determineVisibleItem()
        this.$el.style.scrollBehavior = null;
    },
    
    determineVisibleItem() {
        const sliderOffset = this.$el.getBoundingClientRect().left
        this.items.forEach(item => {
            const rect = item.node.getBoundingClientRect()
            const slideMiddle = rect.x - sliderOffset + rect.width/2
            if(slideMiddle > 0 && slideMiddle < rect.width) {
                this.visibleItemIndex = item.index
            }
        })
    },
    
}))